import React from 'react';
import Slider from 'react-slick';
import { Box } from '@mui/material';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';


import img1 from '../assets/hero/01.webp';
import img2 from '../assets/hero/02.webp';
import img3 from '../assets/hero/03.webp';
import img4 from '../assets/hero/04.webp';
import img5 from '../assets/hero/05.webp';
import img6 from '../assets/hero/06.webp';

const images = [img1, img2, img3, img4, img5, img6];

export default function HeroCarousel() {
  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4200,
    speed: 900,
    slidesToShow: 1,
    slidesToScroll: 1,
    pauseOnHover: false,
    arrows: false,
    lazyLoad: 'ondemand', // ← activa lazy load de react-slick
  };

  return (
    <Slider {...settings}>
      {images.map((src, i) => (
        <Box
          key={i}
          component="img"
          src={src}
          alt={`joya-${i}`}
          className="hero-slide" // height: 56vh en tu CSS, con object-fit: cover
          loading="lazy"
        />
      ))}
    </Slider>
  );
}